//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import PrivateRoute from "./PrivateRoute";
import DashboardLayout from "../layouts/DashboardLayout";
import { Inbox } from "../pages/Inbox/Inbox";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/mail"} element={<Inbox />} />
        <Route path={"/mail/:id"} element={<Inbox />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
